import { SET_USER_LOGIN } from '../actions/loggedUser';
import { buildLoggedUser } from '../helpers/loggedUser';
const initialState = {
    fetching: false,
    user: {},
};

export default (state = initialState, action) => {
    switch (action.type) {
        case SET_USER_LOGIN: {
            return {
                ...state,
                fetching: false,
                user: {
                    ...buildLoggedUser(action.payload.user),
                    permission: action.payload.permission,
                    permisionEntities: action.payload.permisionEntities
                }
            };
        }
        default: return state;
    }
};